export default "__VITE_ASSET__2BRqCPvh__"